export enum HvorMyeRoutes {
    OM = '/om',
    ARBEIDSSITUASJON = '/arbeidssituasjon',
    OPPSUMMERING = '/oppsummering',
}
